import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyD3-QPMu7UNaUYDNB_fyYYX-iCMvuNCuds",
  authDomain: "kira-7f565.firebaseapp.com",
  projectId: "kira-7f565",
  storageBucket: "kira-7f565.firebasestorage.app",
  messagingSenderId: "147123256998",
  appId: "1:147123256998:web:dae75dbdc068f70ddbbe67",
  measurementId: "G-P4QFFC3XLL"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const firestore = getFirestore(app);
export const googleProvider = new GoogleAuthProvider().setCustomParameters({
  prompt: "select_account",
});

export default app;
